riot.tag2('platform-event-delegator', '', '', '', function(opts) {
    const self = this;

    function attachEvents() {
      if (self.opts.eventMap) {
        self.opts.eventMap.forEach((eventObj) => {
          const elements = document.querySelectorAll(eventObj.selector);

          for (let i = 0; i < elements.length; i++) {
            elements[i].removeEventListener(eventObj.event, eventObj.fn);
            elements[i].addEventListener(eventObj.event, eventObj.fn);
          }
        });
      }
    }

    self.on('mount', () => {
      attachEvents();
    });

    self.on('update', () => {
      attachEvents();
    });
});
